"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECEIVE_PARTNER_STATUS = exports.REQUEST_PARTNER_STATUS = exports.RECEIVE_USER_STATUS = exports.REQUEST_USER_STATUS = exports.IDENTIFY_GUEST_USER = exports.IDENTIFY_USER = exports.RECEIVE_USER = exports.REQUEST_USER = void 0;
var REQUEST_USER = 'zola/user/REQUEST_USER';
exports.REQUEST_USER = REQUEST_USER;
var RECEIVE_USER = 'zola/user/RECEIVE_USER';
exports.RECEIVE_USER = RECEIVE_USER;
var IDENTIFY_USER = 'zola/user/IDENTIFY_USER';
exports.IDENTIFY_USER = IDENTIFY_USER;
var IDENTIFY_GUEST_USER = 'zola/user/IDENTIFY_GUEST_USER';
exports.IDENTIFY_GUEST_USER = IDENTIFY_GUEST_USER;
var REQUEST_USER_STATUS = 'zola/user/REQUEST_USER_STATUS';
exports.REQUEST_USER_STATUS = REQUEST_USER_STATUS;
var RECEIVE_USER_STATUS = 'zola/user/RECEIVE_USER_STATUS';
exports.RECEIVE_USER_STATUS = RECEIVE_USER_STATUS;
var REQUEST_PARTNER_STATUS = 'zola/user/REQUEST_PARTNER_STATUS';
exports.REQUEST_PARTNER_STATUS = REQUEST_PARTNER_STATUS;
var RECEIVE_PARTNER_STATUS = 'zola/user/RECEIVE_PARTNER_STATUS';
exports.RECEIVE_PARTNER_STATUS = RECEIVE_PARTNER_STATUS;